import { APIEndpoint } from "../../Infrastructure/Api/client";
import { SAVE_TO_SHORTLIST } from "../shortlist/actionTypes";

export class ShortlistEndpoint extends APIEndpoint {
  url = 'api/showroom/save';
  requestType = 'POST';
  action;
  
  constructor() {
    super();
    this.action = SAVE_TO_SHORTLIST;
  }

  // TODO: config
  makeMockRequest(config) {
    return Promise.resolve({ data: null });
    // TODO: base rejection case on config
    // return Promise.reject(new Error('Rejected!'));
  }
}
